import React, { ChangeEventHandler, useCallback, useEffect, useState } from 'react';
import { ClearButton, Input } from '@shared/UI';
import { FaSearch } from 'react-icons/fa';
import { debounce } from '@shared/utils';
import { useSearchQuery } from './lib';
import { SearchInputProps } from './interfaces';
import classnames from 'classnames';
import './SearchInput.scss';

export const SearchInput: React.FC<SearchInputProps> = (props) => {
    const { setValue, placeholder, queryName, initialSearch, className } = props;

    const { querySearch, setQuerySearch } = useSearchQuery({
        initialSearch,
        queryName,
    });

    const [search, setSearch] = useState<string>(querySearch);

    const changeValue = useCallback(
        debounce((value: string) => {
            setValue(value);
        }, 400),
        [setValue],
    );

    const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(({ target: { value } }) => {
        setSearch(value);
    }, []);

    useEffect(() => {
        changeValue(search);
        setQuerySearch(search);
    }, [search, changeValue, setQuerySearch]);

    const clear = useCallback(() => {
        setSearch('');
    }, []);

    return (
        <Input
            prefixIcon={<FaSearch />}
            suffixIcon={search ? <ClearButton /> : undefined}
            onSuffixIconClick={clear}
            wrapperClassName={classnames('feature-search-input', className)}
            placeholder={placeholder || 'Search'}
            onChange={onChange}
            value={search}
            inputSize='large'
        />
    );
};
